<template>
  <div class="bottom-drawer mx-0 border-top-round d-flex flex-column" @click.stop="false;" dir="rtl">
    <div class="desktop-only closeX pointer" @click="$emit('close')">X</div>
    <div class="d-flex flex-row padding-20 hidden shadow-bottom" ref="closeBar" style="padding-top:5px; padding-bottom: 10px;">
      <div class="f22-l23-sb mobile-or-tablet" style="padding-top:10px;" @click="$emit('close')">X</div>
      <div class="f22-l23-sb flex-grow-1 text-center" style="padding-top:10px;"> {{dish.title}} </div>
    </div>
    <div class="flex-grow-1 p-0 position-relative" style="overflow-y:auto;" @scroll="showHideCloseBar" id="dishDrawer">
      <SectionImageComponent :image="$responsive(dish.pictures)" />
      <div class="mobile-or-tablet position-absolute cff pointer f22-l23-sb" style="top: 15px; right: 20px" @click="$emit('close')">X</div>
      <LikeComponent v-if="dish.likes" :likes="dish.likes" position="top-right" @click.stop="false;" />
      <RatingComponent class="position-absolute pointer" @click="scrollToRating" :rating="dish.rating_preview" style="top: 15px; left: 20px; background-color:rgba(255,255,255,0.7); border-radius: 10px; padding-left:5px; padding-right:5px;" />
      <div class="d-flex flex-column" style="padding-left:20px; padding-right:20px; padding-top:20px;">
        <div class="d-flex flex-row">
          <div class="f22-l23-sb flex-grow-1">
            {{dish.title}}
          </div>
          <div class="d-flex flex-column text-left" style="min-width:120px;">
            <div class="d-flex flex-row f18-l21-m" dir="rtl">
              <div class="flex-grow-1"></div>
              <PriceComponent v-if="dish.price_options.about_price.display.discounted" class="stroke margin-space-after" :value="dish.price_options.about_price.display.nominal_price" />
              <PriceComponent :value="dish.price_options.about_price.display.price || dish.price_options.about_price.display.unit_price" />
            </div>
            <div class="f18-l21-m red">{{dish.price_options.about_price.display.text}}</div>
            <div class="f14-l19">{{dish.price_options.about_price.display.min_amount_text}}</div>
            <div class="f14-l19">{{dish.price_options.about_price.display.content_text}}</div>
          </div>
        </div>
        <!-- <HorizontalSplitter v-if="dish.about.description" class="margin-top-10" /> -->
        <div v-if="dish.about.description">
          <div class="margin-top-10">
            <div class="f14-l17 darkgrey" style="margin-top:10px;" v-html="dish.about.description.description_html"></div>
          </div>
        </div>
        <HorizontalSplitter v-if="dish.about.description" class="margin-top-10"/>

        <div class="text-center margin-top-10 ">
          <span v-if="dish.about.custom_availability_text_html" class="f14-l17">{{ dish.about.custom_availability_text_html }}</span>
        </div>

        <DealLegendComponent :legend="dish.legend" v-if="dish.legend" @item-click="handleItemClick" />

        <div class="text-center margin-top-10 ">
          <span class="f13-l16-l" v-for="(p,pkey) in dish.tags" :key="pkey">{{p.text}}<span v-if="pkey<Object.keys(dish.tags).length-1" class="red strong"> | </span> </span>
        </div>

        <!-- <div v-if="dish.tags && dish.tags.length>0">
          <DishPreferenceComponent v-for="p in dish.tags" :preference="p" :key="p.search_url" />
        </div> -->
        <HorizontalSplitter class="margin-top-10" />
        <!-- <pre fordebuggging>{{selectedDealOptions}}</pre> -->
        <div class="row-flex margin-top-20 f16-l19" ref="dealPortions">
          <div class=" margin-top-20" v-for="(portion, portionIdx) in dish.deal_info.deal_options.portions" :key="portionIdx">
            <span class="f16-l19-m df22-l19-m red-link" v-html="portion.title_html"></span>
            <div v-for="(category,categoryIdx) in portion.categories" :key="categoryIdx">
              <div class="f16-l19-m df22-l19-m margin-top-20">{{category.selection.selection_text}}</div>
              <CheckboxLimiter :limit="category.selection.max_selection" :ref="`p` + (portionIdx) + `_c` + (categoryIdx)">
                <div v-for="(opt, optionIdx) in category.options" :key="optionIdx" class="deal-bottom-separator">
                  <div class="d-flex flex-row margin-top-5 ">
                    <input :option_id="opt.id" type="checkbox" :class="`align-self-center red-checkbox portion portion_` + 'p' + portionIdx + '_c' + categoryIdx" :fixed="category.fixed" :disabled="category.fixed" :checked1="category.fixed" :name="'p' + portionIdx + '_c' + categoryIdx" :id="'p' + portionIdx + '_c' + categoryIdx + '_o' + optionIdx" style="margin-left: 8px; margin-right: 8px;" @change="selecteCategoryOption(portion,portionIdx,categoryIdx,optionIdx)" />
                    <ImgImage :img="$responsive(opt.pictures).url" :magnifier="opt?.image_magnifier"  class="margin-lr-5" />
                    <div class="label-container">
                      <label v-html="opt.title_html" :for="'p' + portionIdx + '_c' + categoryIdx + '_o' + optionIdx" class="f14-l17 red-link align-self-center"></label>
                      <a v-if="opt.dish_link" class="red-link" :href="opt.dish_link.link" target="_blank">{{ opt.dish_link.text }}</a>
                    </div>
                  </div>
                  <!-- <span dir="ltr" fordebugging>
                  c[{{category.fixed}}] pid[{{portion.price_option_id}}] spid[{{getSelectedPortion().id}}]
                  </span> -->
                  
                </div>
              </CheckboxLimiter>
            </div>
          </div>
        </div>

        <HorizontalSplitter v-if="dish.about.contents" class="margin-top-20 margin-bottom-20" />
        <div v-if="dish.about.contents">
          <div class="f16-l19-m df22-l19-m">{{dish.about.contents.label}}</div>
          <div class="f14-l17 darkgrey" style="margin-top:10px;" v-html="dish.about.contents.contents_html"></div>
          <div class="f14-l17 darkgrey margin-top-10" v-if="dish.about.contents_disclaimer" v-html="dish.about.contents_disclaimer.text"></div>
        </div>

        <HorizontalSplitter class="margin-top-20 margin-bottom-20" />
        <div class="row-flex f16-l19 df22-l19">
          <div v-for="(portion, idx) in dish.price_options.portions" :key="idx">
            <input class="red-radio" type="radio" style="margin: 10px 8px;" name="portion" :checked="portion.portion.id==selectedPortion.id" :id="`portion_`+idx" @change="selectPortionLevel(portion.portion);" />
            <label :for="`portion_`+idx">{{portion.portion.name}} <span class="f16-l19-m">
                <PriceComponent :value="portion.portion.unit_price" /></span>
              <span v-if="portion.portion.discounted" class="f16-l19-m stroke">{{ " " }}<PriceComponent :value="portion.portion.nominal_price" /></span> 
              </label>
          </div>
        </div>
        <HorizontalSplitter class="margin-top-20" />
        <div class="accordion accordion-flush p-0 red-link" id="accordionfaq">
          <FaqItemComponent v-if="dish.about.variations?.label" :q="dish.about.variations.label" :a="dish.about.variations.text" :show="true" :a2="dish.about.variations.help_text_html" id="variations"  ref="variations"/>
          <!-- <FaqItemComponent v-if="dish.about.description" :q="dish.about.description.label_text" :a="dish.about.description.description_html" :show="true" /> -->
          <FaqItemComponent v-if="dish.ingredients" :q="dish.ingredients.title" :a="dish.ingredients.text" :a2="dish.ingredients.dishes.dish.ingredients_html"   id="ingredients" ref="ingredients"/>
          <FaqItemComponent v-if="dish.heating_notes" :q="dish.heating_notes.title_html" :a="dish.heating_notes.description_html"  ref="heating_notes" />
          <FaqItemComponent v-if="dish.storage_notes" :q="dish.storage_notes.title_html" :a="dish.storage_notes.description_html" ref="storage_notes" />
        </div>
        <HorizontalSplitter class="margin-top-20 margin-bottom-20" />
        <div class="padding-20" id="dishRatingSection">
          <CookSectionRating :rating="dish.rating_details" :showOverview="false" />
        </div>
      </div>
    </div>
    <div style="height:90px;padding: 20px" class="d-flex flex-row justify-content-center user-select-none">
      <div class="d-flex flex-row align-items-center addToCartWrapper">
        <div ref="btnPlus" class="amountButton pointer" @click="amountPlus(1)">+</div>
        <div class="red" id="amount" style="margin: 0 10px">{{amount}}</div>
        <div ref="btnMinus" class="amountButton pointer" @click="amountPlus(-1)">-</div>
      </div>
      <div class="d-flex flex-row align-items-center addToCartButton  pointer" @click="submitToCart()">
        <div class="white f16-l19-m df22-l19-m pointer" style="margin: 0 10px;">{{addToCartText}}</div>
        <div class="white flex-grow-1"></div>
        <div class="white f16-l19-m df22-l19-m price-min-width" id="price">
          <PriceComponent :value="price" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global $ */
import {formSubmit} from '@/modules/configuration.js';
import {openCart} from '@/modules/utils.js';
import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
import FaqItemComponent from "@/components/FaqItemComponent.vue";
// import DishPreferenceComponent from "@/components/DishPreferenceComponent.vue";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
import RatingComponent from "@/components/generic/RatingComponent.vue";
import CookSectionRating from "@/components/CookSectionRating.vue";
import CheckboxLimiter from "@/components/generic/CheckboxLimiter.vue";
import LikeComponent from "@/components/generic/LikeComponent.vue";
import ImgImage from "@/components/generic/ImgImage.vue";
import PriceComponent from "@/components/generic/PriceComponent.vue";
import DealLegendComponent from '@/components/DealLegendComponent.vue';
export default {
  props: {
    dish: {}
  },
  components: {
    ImgImage,
    SectionImageComponent,
    FaqItemComponent,
    HorizontalSplitter,
    // DishPreferenceComponent,
    RatingComponent,
    CookSectionRating,
    CheckboxLimiter,
    LikeComponent,
    PriceComponent,
    DealLegendComponent
  },
  data() {
    return {
      loading: true,
      amount: 0,
      selectedPortion: {},
      selectedDealOptions: {},
      cumulative: true,
    }
  },
  computed: {
    price() {
      return this.amount * (this.getSelectedPortion()?.unit_price || 0);
    },
    addToCartText() {
      return this.getSelectedPortion()?.action_btn?.label;
    }
  },
  methods: {
    setupDish() {
      const data = this.dish;
      this.selectedPortion = data?.price_options?.portions[0]?.portion || {};
      this.amount = this.selectedPortion.min || 1;
      this.cumulative = data.deal_info.cumulative_deal;

      //setup fixed
      // for (let portionIdx in data.deal_info.deal_options.portions) {
      const portionIdx = 0;
      let portion = data.deal_info.deal_options.portions[portionIdx];
      for (let categoryIdx in portion.categories) {
        let category = portion.categories[categoryIdx];
        if (category.fixed) {
          // this.selectedDealOptions["p" + portionIdx + "_c" + categoryIdx] = this.selectedDealOptions["p" + portionIdx + "_c" + categoryIdx] || [];
          for (let optionIdx in category.options) {
            // this.selectedDealOptions["p" + portionIdx + "_c" + categoryIdx]["" + optionIdx] = true;
            this.updateSelectedDealOptions(portionIdx, categoryIdx, optionIdx, true);
          }
        }
      }
      // }

      this.loading = false;
      if (data.title) {
        document.body.classList.add('noscroll');
      }
    },
    enableDisableButtons() {
      const btnPlus = this.$refs.btnPlus;
      const btnMinus = this.$refs.btnMinus;
      const selected = this.getSelectedPortion();
      if (this.amount == selected.min) {
        btnMinus.classList.add('disabled');
      } else {
        btnMinus.classList.remove('disabled');
      }
      if (this.amount == selected.max) {
        btnPlus.classList.add('disabled');
      } else {
        btnPlus.classList.remove('disabled');
      }
    },
    amountPlus(toAdd) {
      const selected = this.getSelectedPortion();
      let amount = this.amount + (toAdd || 0);
      if (amount < (selected.min || 1)) amount = (selected.min || 1);
      if (amount > (selected.max || 10)) amount = (selected.max || 10);
      this.amount = amount;
      this.enableDisableButtons();
    },
    selectPortionLevel(portion) {
      //level 0 is always selection
      // cumulative means if you select 2 it add 1
      // !cumulative means select 1 or 2
      this.selectedPortion = portion;
      this.amountPlus(0); //to fix min/max based on portion
      const p_level = portion.price_level;
      if (p_level == 1) { //leave p0
        for (let key in this.selectedDealOptions) {
          const shortKey = key.substr(0, 2);
          if (shortKey === 'p1' || shortKey === 'p2') {
            delete this.selectedDealOptions[key];
          }
        }
      }
      if (p_level == 2) { //leave p0 and p1
        for (let key in this.selectedDealOptions) {
          const shortKey = key.substr(0, 2);
          if (shortKey === 'p2') {
            delete this.selectedDealOptions[key];
          }
        }
      }
      if (p_level == 3 || !this.cumulative) { //leave p0 and p2 (And if cumulative leave p1)
        for (let key in this.selectedDealOptions) {
          const shortKey = key.substr(0, 2);
          if (shortKey === 'p1') {
            delete this.selectedDealOptions[key];
          }
        }
      }

      // for (let key in this.selectedDealOptions) {
      //   const shortKey = key.substr(0, 2);
      //   if (p_level == 1) { //leave on p0
      //     if (shortKey === 'p1' || shortKey === 'p2') {
      //       delete this.selectedDealOptions[key];
      //     }
      //   } else if (p_level == 2) {
      //     if (shortKey === 'p2') { //leave p0 and p1
      //       delete this.selectedDealOptions[key];
      //     }
      //   } else if (p_level == 3) { //if !comulative leave p0
      //     if (!this.cumulative && shortKey === 'p1') {
      //       delete this.selectedDealOptions[key];
      //     }
      //   }
      // }
      for (let key in this.$refs) {
        const shortKey = key.substr(0, 2);
        if (p_level == 1) {
          if (shortKey === 'p1' || shortKey === 'p2') {
            this.$refs[key][0].unselectAll();
          }
        } else if (p_level == 2) {
          if (shortKey === 'p2') {
            this.$refs[key][0].unselectAll();
          }
        } else if (p_level == 3) {
          if (!this.cumulative && shortKey === 'p1') {
            this.$refs[key][0].unselectAll();
          }
        }
      }
      this.autoSelectFixedCategoryForSelectedPortions();

    },
    getSelectedPortion() {
      if (this.selectedPortion.unit_price) return this.selectedPortion;
      if (this.dish?.price_options) return this.dish.price_options.portions[0].portion;
      return null;
    },
    async submitToCart() {
      const dealPortionsElm = this.$refs.dealPortions;
      const checkedCheckboxes = dealPortionsElm.querySelectorAll("input[type=checkbox]:checked");
      let selectedOptionIds = [];
      for (let i = 0; i < checkedCheckboxes.length; i++) {
        selectedOptionIds.push(checkedCheckboxes[i].getAttribute("option_id"));
      }
      let data = {
        "amount": this.amount,
        "deal_selection": '{"selected_options":[' + selectedOptionIds.join(',') + ']}',
        "portion_id": this.getSelectedPortion().id
      };
      let response = await formSubmit(this, null, this.getSelectedPortion().action_btn.url + "&amount=" + this.amount, data);

      openCart(this, response);
      if (!this.dish?.about.no_city){
        this.$emit('close');
      }
    },
    autoSelectRightPortionPrice() {
      let optionsFromPortions = [false, false, false];
      for (const pco in this.selectedDealOptions) {
        let portionIndex = +pco.split('_')[0].substring(1);
        optionsFromPortions[portionIndex] = true;
      }
      let selected;
      if (optionsFromPortions[2] && this.dish.price_options.portions.length > 2) {
        selected = this.dish.price_options.portions[2].portion;
      } else if (optionsFromPortions[1] && this.dish.price_options.portions.length > 1) {
        selected = this.dish.price_options.portions[1].portion;
      } else {
        selected = this.dish.price_options.portions[0].portion;
      }
      this.selectedPortion = selected;
      this.autoSelectFixedCategoryForSelectedPortions();
      this.amountPlus(0);
    },
    autoSelectFixedCategoryForSelectedPortions() {
      const priceLevel = this.selectedPortion.price_level;
      // console.log('----');
      // console.log(this.selectedPortion);
      // console.log("price level: ", priceLevel);
      // console.log("cumulative: ", this.cumulative);
      this.dish.deal_info.deal_options.portions.forEach((portion, pidx) => {
        if (this.cumulative) {
          if (pidx >= priceLevel) {
            return;
          }
        } else {
          if (priceLevel == 1 && pidx > 0) return;
          if (priceLevel == 2 && pidx > 1) return;
          if (priceLevel == 3 && pidx == 1) return;
        }
        portion.categories.forEach((category, cidx) => {
          if (category.fixed) {
            category.options.forEach((option, oidx) => {
              const elmId = "#p" + pidx + "_c" + cidx + "_o" + oidx;
              $(elmId).prop("checked", true);
              this.updateSelectedDealOptions(pidx, cidx, oidx, true);
            })
          }
        });
      })
    },
    updateSelectedDealOptions(pidx, cidx, oidx, value) {
      const cateogryId = "p" + pidx + "_c" + cidx;
      this.selectedDealOptions[cateogryId] = this.selectedDealOptions[cateogryId] || [];
      this.selectedDealOptions[cateogryId]["" + oidx] = value;
    },
    selecteCategoryOption(portion, portionIdx, categoryIdx, optionIdx) {
      const elmId = "p" + portionIdx + "_c" + categoryIdx + "_o" + optionIdx;
      const elm = document.getElementById(elmId);
      if (portion.categories[categoryIdx].fixed) {
        elm.checked = true;
        return;
      }
      this.updateSelectedDealOptions(portionIdx, categoryIdx, optionIdx, elm.checked);
      // this.selectedDealOptions[id] = this.selectedDealOptions[id] || [];
      // this.selectedDealOptions[id]["" + optionIdx] = elm.checked;


      if (elm.checked && !this.cumulative && portionIdx > 0) {
        //if portionIndex2 seleted - clear 3 and vice versa (but zero based)
        const portionIndexToDisable = (portionIdx == 1) ? 'p2' : 'p1';
        for (let key in this.selectedDealOptions) {
          const portionPart = key.substr(0, 2);
          if (portionPart == portionIndexToDisable) {
            delete this.selectedDealOptions[key];
          }
        }
        for (let key in this.$refs) {
          const shortKey = key.substr(0, 2);
          if (shortKey == portionIndexToDisable) {
            this.$refs[key][0].unselectAll();
          }
        }
      }
      this.autoSelectRightPortionPrice();
    },
    showHideCloseBar(evt) {
      const closeBar = this.$refs.closeBar;
      if (evt.srcElement.scrollTop > 200) {
        closeBar.classList.remove('hidden');
      } else {
        closeBar.classList.add('hidden');
      }
    },
    async scrollToRating() {
      const scrollToEl = document.getElementById("dishRatingSection");
      const containerElement = document.getElementById("dishDrawer");
      if (scrollToEl) {
        const y = scrollToEl.getBoundingClientRect().top - 100;
        await this.$nextTick();
        containerElement.scrollTo({top: y, behavior: 'smooth'});
      }
    },
    handleItemClick(id) {
      // Access specific FaqItemComponent using refs
      const faqItem = this.$refs[id]; // Use the id to reference the specific component
      if (faqItem) {
        faqItem.toggle();
      }
    }
  },
  mounted() {
    this.setupDish();
    this.autoSelectFixedCategoryForSelectedPortions();
    this.enableDisableButtons();
    this.emitter.on("city-selected", () => {
      this.submitToCart();
    });

  },
  unmounted() {
    this.emitter.off("city-selected");
  },
  // updated() {
  //   this.setupDish();
  //   this.autoSelectFixedCategoryForSelectedPortions();
  //   this.enableDisableButtons();
  // }
}
</script>
<style scoped>
.bottom-drawer {
  display: block;
  background-color: white;
  position: fixed;
  z-index: 2000;
  bottom: 0;
  left: 0;
  right: 0;
  top: 100px;
  overflow: none;
}

@media (min-width: 1200px) {
  .bottom-drawer {
    width: 510px !important;
    left: 50% !important;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    transform: translateX(-50%);
  }
}

.addToCartWrapper {
  height: 50px;
  background-color: #ffcfd2;
  border-radius: 0 30px 30px 0;
  padding: 10px 15px 10px 10px;
}

.addToCartButton {
  height: 50px;
  background-color: #ef3d49;
  border-radius: 30px 0 0 30px;
  padding: 10px 10px 10px 15px;
}

.amountButton {
  background-color: white;
  border-radius: 15px;
  height: 30px;
  width: 30px;
  text-align: center;
  color: red;
  font-size: 24px;
  line-height: 24px;
}

.amountButton.disabled {
  background-color: #eee;
  color: white;
}

.closeX {
  position: absolute;
  left: -40px;
  color: white;
  font-size: 28px;
  top: -10px;
}

.label-container {
  display: flex;
  position: relative;
  width: 100%;
}

.label-container label {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  align-self: flex-start; /* Align the label horizontally with the image */
}

@media(min-width: 760px) {
  .label-container a {
    font-size: 14px !important;
    position: absolute;
    bottom: 0;
    align-self: flex-start; /* Align the link horizontally with the image */
  }
}
@media(max-width: 760px) {
  .label-container label {
    font-size: 14px !important;
    line-height: 14px !important;
  }

  .label-container a{
    font-size: 12px !important;
    position: absolute;
    bottom: -6px;
    align-self: flex-start;
  }
}
</style>